<div class="dxp-container-fluid">
  <div class="dxp-row landing-page-title-row">
    <div class="dxp-col-md-12 landing-page-title-content">
      <dxp-content-item content-type="content-image-text" header-type="image" orientation="horizontal"
        content-item-type="media-on-top" content-item-title="Cross Border Control" position-of-media="right"
        content-item-title-target="false"
        description="Cross Border Control (XBC) is a backoffice application used for managing and supporting XBS PINS transactions"
        category-tag="" src="assets/images/illustration.svg" alt="Mastercard" overlay=false responsive=true
        icon-type="light" content-item-action-list="content-item-action-list" fetchpriority="high">
      </dxp-content-item>
    </div>
  </div>
  <div>
    <div class="dxp-row landing-page-bookmark-resources">
      <div class="dxp-col-md-12">
        <div class="dxp-bg-initial dxp-col-md-12">
          <dxp-flex-layout>
            <dxp-flex-layout-item slot="column-1" column-width-sm="8" column-width-lg="9"
              padding-style-sm="10px 0px 0px 15px" class="bookmark-header">
              <p class="dxp-pt-5 dxp-bold dxp-uppercase">BOOKMARKED</p>
            </dxp-flex-layout-item>
          </dxp-flex-layout>

          <dxp-flex-layout class="bookmarks">
            <dxp-flex-layout-item *ngFor="let bookmark of this.bookmarks; let i = index" slot="column-{{i + 1}}"
              column-width-sm="12" column-width-lg="4"
              [paddingStyleSm]="(i + 1 <= 3) ?'0px 15px 10px 15px': '10px 15px'">
              <div class="dxp-font-size-md dxp-bold dxp-pb-1 dxp-link-color">
                <dxp-link state="enabled" type="dxp-btn-custom-link" [text]="bookmark.name" [href]="bookmark.path"
                  [ariaLabel]="bookmark.ariaLabel"></dxp-link>
              </div>
              <div class="bookmark-description">{{bookmark.description}}</div>
            </dxp-flex-layout-item>

          </dxp-flex-layout>
        </div>
      </div>
    </div>
  </div>
</div>